import { AlertData } from "./alertsInterfaces";
import { Dispatcher } from "../../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { NavigateFunction } from "react-router-dom";
import { handleAlertButtonsFill } from "./handleAlertButtonsFill";
import { getActiveIgnoreZones } from "./getActiveIgnoreZones";
import { checkForRedirectAndFetchMP4 } from "./checkForRedirectAndFetchMP4";
import { VlmFilterType } from "./vlmFilters";
import {
  arrowStateForNavigableIndex,
  getNavigableAlerts,
  isSameAlertRow,
  readStoredAlertsTableSort,
} from "./getNavigableAlerts";

/**
 * Handles auto-advancing to the next row after labeling an alert.
 */
export const handleAutoAdvanceAfterLabeling = (
  currentRow: AlertData,
  alertData: AlertData[],
  setAlertData: Dispatcher<AlertData[]>,
  setSelectedRow: Dispatcher<AlertData>,
  setSelectedButtonsFilled: Dispatcher<any>,
  setMP4URL: Dispatcher<string>,
  setVideoClipLoading: Dispatcher<boolean>,
  setSeeMoreURL: Dispatcher<string>,
  setForwardArrowDisabled: Dispatcher<boolean>,
  setBackArrowDisabled: Dispatcher<boolean>,
  setShowRefreshButton: Dispatcher<boolean>,
  setSelectedAlertCameraInfo: any,
  setIgnoreZonesSelectedAlert: any,
  navigate: NavigateFunction,
  userFilters: any,
  detectionType: string,
  outcomeFilterType: string,
  getCurrentSelectedRowKey: () => string | null,
  setVideoProcessing: Dispatcher<boolean>,
  useAsyncGeneration: boolean,
  syncSelectedRowRef: (row: any) => void,
  vlmFilterType: VlmFilterType = "All"
) => {
  setMP4URL("");
  setVideoClipLoading(true);
  setShowRefreshButton(false);

  const isUnresolvedFilter = userFilters?.filter_type === "UNCLAIMED";
  const storedSort = readStoredAlertsTableSort();
  const navigableFrom = (rows: AlertData[]) =>
    getNavigableAlerts({
      alertData: rows,
      detectionType,
      outcomeFilterType,
      vlmFilterType,
      showVlmFilters: true,
      order: storedSort.order,
      orderBy: storedSort.orderBy,
    });

  const filteredAlertData = navigableFrom(alertData);
  const currentIndex = filteredAlertData.findIndex((alert: any) =>
    isSameAlertRow(alert, currentRow)
  );

  let newAlertData = [...alertData];
  let nextRow: AlertData | null = null;

  if (isUnresolvedFilter) {
    newAlertData = newAlertData.filter(
      (alert: AlertData) => !isSameAlertRow(alert, currentRow)
    );
    const remainingFilteredData = navigableFrom(newAlertData);
    if (remainingFilteredData.length > 0) {
      const nextIndex =
        currentIndex >= remainingFilteredData.length ? 0 : currentIndex;
      nextRow = remainingFilteredData[nextIndex];
    }
  } else if (filteredAlertData.length <= 1) {
    nextRow = currentRow;
  } else if (currentIndex === filteredAlertData.length - 1) {
    nextRow = filteredAlertData[0];
  } else {
    nextRow = filteredAlertData[currentIndex + 1];
  }

  if (isUnresolvedFilter) {
    setAlertData(newAlertData);
  }

  if (nextRow) {
    const finalAlertData = isUnresolvedFilter ? newAlertData : alertData;
    finalAlertData.forEach((object: AlertData) => {
      object.selected = false;
    });

    const nextRowIndex = finalAlertData.findIndex((alert: any) =>
      isSameAlertRow(alert, nextRow)
    );

    if (nextRowIndex >= 0) {
      finalAlertData[nextRowIndex].selected = true;
    }

    setSelectedRow(nextRow);
    syncSelectedRowRef(nextRow);
    localStorage.setItem("selectedRowAlerts", JSON.stringify(nextRow));
    setSeeMoreURL(nextRow.alert_url);
    setAlertData([...finalAlertData]);
    handleAlertButtonsFill(nextRow, setSelectedButtonsFilled);
    getActiveIgnoreZones(
      nextRow.camera_pk,
      setSelectedAlertCameraInfo,
      setIgnoreZonesSelectedAlert,
      navigate
    );
    checkForRedirectAndFetchMP4(
      nextRow,
      navigate,
      setMP4URL,
      setVideoClipLoading,
      setShowRefreshButton,
      true,
      getCurrentSelectedRowKey,
      setVideoProcessing,
      useAsyncGeneration
    );

    const remainingForArrows = navigableFrom(
      isUnresolvedFilter ? newAlertData : alertData
    );
    const newPositionIndex = remainingForArrows.findIndex((alert: any) =>
      isSameAlertRow(alert, nextRow)
    );
    const arrows = arrowStateForNavigableIndex(
      newPositionIndex,
      remainingForArrows.length
    );
    setBackArrowDisabled(arrows.backDisabled);
    setForwardArrowDisabled(arrows.forwardDisabled);
  } else {
    setSelectedRow(null as any);
    syncSelectedRowRef(null);
    localStorage.removeItem("selectedRowAlerts");
    setSeeMoreURL("");
    setBackArrowDisabled(true);
    setForwardArrowDisabled(true);
    setVideoClipLoading(false);
  }
};
